import { useEffect, useState, useRef } from "react";

function CypherMenu({ tokenId, secretWord, dudeAction, layer1, layer2, layer3, bitEnvironment, bitPalette, lsb, gridSize, gridResolution, levelProgression, ownerAddy, message }) {

    function swapScripts3() {
        var script = document.getElementById("svgScript3");
        if (script != null) {
            let newScript = document.createElement("script");
            newScript.text = script.textContent;
            var cliNode = document.getElementById("doc_C")
            if (cliNode != null) {
                cliNode.after(newScript);
                script.remove();
            }
        }
    }

    useEffect(() => {
        document.getElementById('menuSandbox').innerHTML = renderMenu(tokenId, secretWord, dudeAction, layer1, layer2, bitEnvironment, bitPalette, lsb, gridSize, gridResolution, levelProgression, ownerAddy, message);
        swapScripts3();
    })

    useEffect(() => {
        document.getElementById('menuSandbox').innerHTML = renderMenu(tokenId, secretWord, dudeAction, layer1, layer2, bitEnvironment, bitPalette, lsb, gridSize, gridResolution, levelProgression, ownerAddy, message);
        swapScripts3();
    }, [tokenId, secretWord, dudeAction, layer1, layer2, bitEnvironment, bitPalette, lsb, gridSize, gridResolution, levelProgression, ownerAddy,])

    var seedrandom = require('seedrandom');

    const palettes = [{ values: { a: "#00ff00", b: "#ffffff", c: "#000000" }, names: { a: "green", b: "white", c: "black" } }, { values: { a: "#00ff00", b: "#000000", c: "#ffffff" }, names: { a: "green", b: "black", c: "white" } }, { values: { a: "#000000", b: "#00ff00", c: "#ffffff" }, names: { a: "black", b: "green", c: "white" } }, { values: { a: "#000000", b: "#00ff00", c: "#00ff00" }, names: { a: "black", b: "green", c: "green" } }, { values: { a: "#000000", b: "#ffffff", c: "#ffffff" }, names: { a: "black", b: "white", c: "white" } }, { values: { a: "#000000", b: "#ffffff", c: "#00ff00" }, names: { a: "black", b: "white", c: "green" } }, { values: { a: "#000000", b: "#ff00ff", c: "#00ffff" }, names: { a: "black", b: "fuschia", c: "aqua" } }, { values: { a: "#000000", b: "#ffffff", c: "#00ff00" }, names: { a: "black", b: "white", c: "green" } }, { values: { a: "#0000ff", b: "#ff0000", c: "#000000" }, names: { a: "blue", b: "red", c: "black" } }, { values: { a: "#000000", b: "#ff0000", c: "#ffff00" }, names: { a: "black", b: "red", c: "yellow" } }, { values: { a: "#0000ff", b: "#ffff00", c: "#ff00ff" }, names: { a: "blue", b: "yellow", c: "fuschia" } }, { values: { a: "#000000", b: "#ffffff", c: "#ffffff" }, names: { a: "black", b: "white", c: "white" } }]
    function cli(e) {
        return `<style>.hL{fill:#00ff00;}.fText{font-family:MonoPixel;padding-top:10px;font-size:10px;text-align: center;color:${e.values.a}}.tText{font-family:MonoPixel;font-size:18px;text-align: center;color:${e.values.a}}.h1Text{font-family:MonoPixel;font-size:14px;color:${e.values.a}}.h2Text{font-family:MonoPixel;font-size:10px;color:${e.values.a}}.pText{font-family:Andale Mono;width:360px;font-size:7px;color:${e.values.a}}.scroller {scrollbar-color: ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b} ${e.values.c}00;scrollbar-width: thin;overflow-y:auto;}.wPaper{height:320px;width: 100%;}.form{height:150px;border-left: 0.25px solid ${e.values.a};}.tabContentC1{padding: 5px 0px 0px 5px;display: none;height:320px;border-left: 0.25px solid ${e.values.a};}.tabContentC2{padding: 5px 0px 0px 5px;display: none;width: 365px;height:296px;border-left: 0.25px solid ${e.values.a};}.tabs{display: flex;}.tablinks_C1{width: 48%;}.tablinks_C2{width: 32%;}.tablinks_C1, .tablinks_C2{border: none;border-bottom: 0.25px solid ${e.values.a};background-color: transparent;display: inline-block;}.active{color: ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b};border: 0.25px solid ${e.values.a};border-bottom: none;}.input{font-family: 'Andale Mono';color: ${e.values.a};font-size: 7px;width: 100%;margin-right: 5px;border: 0.25px solid ${e.values.a};background-color: transparent;}.key{height:16px; margin-top:0px;}.input:active, .input:focus{outline: none !important;border: 0.5px solid ${e.values.a};box-shadow: 0 0 10px ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b};}textarea{scrollbar-color: ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b} ${e.values.c}00;scrollbar-width:thin; resize:none; overflow-y:auto; height: 215px;}.subBtn{border: 0.25px solid ${e.values.a};background-color: transparent;width: 30%;display: inline-block;}.subBtn:active{color: ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b};box-shadow: 0 0 10px ${e.values.b === e.values.c ? "white" === e.names.b ? "#00ff00" : "#ffffff" : e.values.b};}.cWp{display:flex;justify-content:space-between;}.cNt{width:auto;align-self:flex-end;}</style><defs><pattern id="pM" x="0" y="0" width="3" height="3" patternUnits="userSpaceOnUse" patternContentUnits="userSpaceOnUse"><circle id="pM" cx="0.5" cy="1" r="0.55" fill="#737373"></circle></pattern><pattern id="gL" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAK0lEQVQ4jWNkYGD4z4AfMOKTZCKgmSAYNWAwGIA3jqEAbzoZeC+MGkAFAwAxXgIecmo1uAAAAABJRU5ErkJggg=="/></pattern><pattern id="gM" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAL0lEQVQ4jWNkYGD4z4AKGNH4eOWZGCgEA28Aun8ZGEgMk4H3AlXCYDQdYIKRlg4ArA0IG+WyAAQAAAAASUVORK5CYII="/></pattern><pattern id="gS" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAKklEQVQ4jWNgYGD4D8UwQBKfiYFCwIhmMrIYUXyKXQAzaTQMRsNgpIcBAJ3lL/GeFeu8AAAAAElFTkSuQmCC"/></pattern><pattern id="rL" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAH0lEQVQ4jWNgGGjAiMT+T45eJkpdMGrAqAGDw4CBBwC2SwEYE2ukzgAAAABJRU5ErkJggg=="/></pattern><pattern id="rM" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIElEQVQ4jWNgGAUDDxiR2P9JUAsHTJS6YNSAwWDAwAMAmewBEMZQY3oAAAAASUVORK5CYII="/></pattern><pattern id="rS" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIElEQVQ4jWNgGAWjYDAARiT2fzxyOAETpS4YeAMGHgAAha0BCIq/fecAAAAASUVORK5CYII="/></pattern><pattern id="wL" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAZElEQVQ4jcWSQQoAMQgDzdL/fzk9bRFN67qXCj0U4jABzW4Pwp+NrAaQmQGsWII8kgqs58jSsGuQ9oYyiOOhESYBb4ikqlEDfFAtfTbwEAD/DCqTrUHsv4McDar+Zr1TPu1dnAmiZDUW/UZ26gAAAABJRU5ErkJggg=="/></pattern><pattern id="off" x="0" y="0" width="1" height="1"><image height="10" width="34" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAQAgMAAAAg3mRlAAAADFBMVEVHcEz///8AAABsbGw6Bac1AAAAAXRSTlMAQObYZgAAAExJREFUCNdj+I8MPjAcYEABh1aBAMMqplUrgBTDyVAQaEDl7mJY1MCwgIFoLtC4Btxc7HpBrliJJrthFROEC3HkBxj3ANgrcI+g+ggATodZx0GeiegAAAAASUVORK5CYII="/></pattern><pattern id="on" x="0" y="0" width="1" height="1"><image height="10" width="34" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAAQAgMAAAAg3mRlAAAADFBMVEVHcEwAAABsbGwA/wDKljyQAAAAAXRSTlMAQObYZgAAAEtJREFUCNdjWIUMFjA0MKCABoZQhgBWBtZQIAiBc+X/A8FfIJeVISAUxm3Axg0IxctlJY0rC3JGbAOqMxpQHBnWAPMCE9hHDGg+AgAsBFS7sgd6DQAAAABJRU5ErkJggg=="/></pattern><pattern id="cL" x="0" y="0" width="1" height="1"><image height="10" width="10" image-rendering="pixelated" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAANElEQVQ4jWNgoBL4D8Ukq2eilguIdQmGPNVdgMsmnC6jmQsI2kxzFwxcGAxcOhg8eYFkAADhwxn1yJnMrgAAAABJRU5ErkJggg=="/></pattern></defs>`
    }

    const p1 = [{
        p1Name: "Rare Pepes"
    }, {
        p1Name: "Cryptopunks"
    }, {
        p1Name: "Coin Flow"
    }, {
        p1Name: "Chart"
    }, {
        p1Name: "Moma Pixels"
    }, {
        p1Name: "PixelMon Reveal"
    }, {
        p1Name: "Crypto Space"
    }, {
        p1Name: "Crypto Voxel"
    }, {
        p1Name: "Circuit Board"
    }, {
        p1Name: "Uniswap"
    }, {
        p1Name: "Mooncats"
    }, {
        p1Name: "MaxPain"
    }];

    const p2 = [{
        p2Name: 'Gas Wars'
    }, {
        p2Name: 'PacMan'
    }, {
        p2Name: 'HardWare Wallet'
    }, {
        p2Name: 'Feels good man'
    }, {
        p2Name: 'Game Over'
    }, {
        p2Name: 'M3t4m4Sk'
    }, {
        p2Name: 'Promising Collab'
    }, {
        p2Name: 'MaxPain'
    }, {
        p2Name: 'Green Chart'
    }, {
        p2Name: 'Press that mint button'
    }, {
        p2Name: 'trashart'
    }, {
        p2Name: 'none'
    }]

    const p3 = [p1[0], p1[3], p1[4], p1[6], p1[7], p1[8], p1[9], p1[11], 'none'];
    function getDude(e, t, a) {
        return [{
            name: "Backdoor Dude"
        }, {
            name: "Bitruvian Dude"
        }, {
            name: "Building Dude"
        }, {
            name: "Dude scrolling"
        }, {
            name: "Fake Dude"
        }, {
            name: "Going to Zero Dude"
        }, {
            name: "Hashing Dude"
        }, {
            name: "Longterm Dude"
        }, {
            name: "Over minting Dude"
        }, {
            name: "Mooning Dude"
        }, {
            name: "Pumping Dude"
        }, {
            name: "Rabbit Hole Dude"
        }, {
            name: "Dude Regulatooors"
        }, {
            name: "Eyes on the Chart"
        }, {
            name: "Rugged Dude"
        }, {
            name: "Scammed Dude"
        }, {
            name: "Dude Walking By"
        }, {
            name: "Transfer Dude"
        }, {
            name: "Follow the Dude"
        }, {
            name: "Secret Dude"
        }][e]
    }

    function renderMenu(tokenId, secretWord, dudeAction, layer1, layer2, bitEnvironment, bitPalette, lsb, gridSize, gridResolution, levelProgression, ownerAddy, message) {
        function seededRandom(sd) {
            const rng = seedrandom(sd);
            return () => rng.quick();
        }
        const rngM = seededRandom(tokenId);
        let sd = [];
        for (let i = 0; i < 50; i++) {
            sd.push(rngM())
        };
        const palette = palettes[bitPalette];
        let svgCode = '<?xml version="1.0" encoding="utf-8" ?>';
        svgCode += `<div id="svg-container"><svg id="cypherdude" baseProfile="full" x="0" y="0" viewBox="0 0 412 412" version="1.1" overflow="visible" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:ev="http://www.w3.org/2001/xml-events" xmlns:xlink="http://www.w3.org/1999/xlink" style="background-color:${palette.values.a}">`;
        // -- GRID -- //
        const _gridSize = gridSize === 128 ? 71 : gridSize === 64 ? 54 : gridSize;
        const mxSq = (levelProgression + 32) / 10;
        const sqrSR = (gridResolution + 1) / 10;
        const cellSize = 512 / _gridSize;
        const squares = [];
        const occupiedCells = new Array(_gridSize).fill().map(() => new Array(_gridSize).fill(false));
        for (let x = 0; x < _gridSize; x++) {
            for (let y = 0; y < _gridSize; y++) {
                if (!occupiedCells[x][y]) {
                    let maxSize = 1;
                    while (
                        x + maxSize < _gridSize &&
                        y + maxSize < _gridSize &&
                        !occupiedCells
                            .slice(x, x + maxSize + 1)
                            .some((row) => row.slice(y, y + maxSize + 1).some((cell) => cell))
                    ) {
                        maxSize++;
                    }

                    let useBigSquare = rngM() < sqrSR;
                    if (useBigSquare) {
                        maxSize = Math.min(Math.floor(rngM() * rngM() * ((mxSq + 1) - 2 + 1)) + 2, maxSize);
                    } else {
                        maxSize = Math.min(Math.floor(rngM() * rngM() * (2 - 1 + 1)) + 1, maxSize);
                    }
                    const rectSize = cellSize * maxSize;
                    const startColor = "#000000";
                    for (let i = x; i < x + rectSize / cellSize; i++) {
                        for (let j = y; j < y + rectSize / cellSize; j++) {
                            occupiedCells[i][j] = true;
                        }
                    }
                    squares.push({ color: startColor, height: rectSize, width: rectSize, x: x * cellSize, y: y * cellSize, opacity: 0, animated: false, orientation: {}, });
                }
            }
        }
        
        var bkgName = '';
        switch (bitEnvironment) {
            case 0:
                bkgName += '32 bits';
                break;
            case 1:
                bkgName += '32 bits animated';
                break;
            case 2:
                bkgName += '64 bits';
                break;
            case 3:
                bkgName += '64 bits animated';
                break;
            case 4:
                bkgName += 'Who dis ?';
                break;
            case 5:
                bkgName += 'Bitcoin genesis block';
                break;
            case 6:
                bkgName += 'Data tunnel';
                break;
            case 7:
                bkgName += 'Meta script';
                break;
            case 8:
                bkgName += 'The Cypherpunk';
                break;
            default:
                break;
        }

        let hasLayer2 = p2[layer2].p2Name != "none";
        let layer2_ = hasLayer2 ? p2[layer2] : '';
        let hasLayer3 = p3[layer3] != "none";
        const dude = getDude(dudeAction, palette, hasLayer3 ? p3[layer3].p1Pat : '');

        // -- DISPLAY -- //
        let chCnt = (Math.floor(((squares.length * 8) - 450) / 64) * 32 + 32).toLocaleString(undefined, { minimumFractionDigits: 0 });
        svgCode+= cli(palette);
        svgCode += `<g id="doc_C" display="block"><rect x="0" y="0" width="412" height="412" fill="${palette.values.c}E6"></rect><rect class="ico" x="400" y="2" width="10" height="10" onclick="c_lose(evt)" stroke="#000000" stroke-width="0.5" fill="#ffffff"></rect><rect x="400" y="2" width="10" height="10" pointer-events="none" fill="url(#cL)"></rect><foreignObject x="14" y="14" width="398px" height="398px">
                <html xmlns="http://www.w3.org/1999/xhtml">
                    <div style=" height:388px; width:396px;">
                        <div class="tText">--- CYPHER DUDES ---</div>
                        <div class="tabs">
                            <button id="dO1_C" class="tablinks_C1 h1Text" onclick="openTab_C(event,1,'whitepaper_C')">Whitepaper</button>
                            <button id="dO1b_C" class="tablinks_C1 h1Text" onclick="openTab_C(event,1,'actions_C')">Token Actions</button>
                        </div>
                        <div id="whitepaper_C" class="tabContentC1">
                            <div class="scroller wPaper pText">
                                <p>THE CYPHERDUDES</p>
                                <p>Cypherdudes is a generative cryptoart series paying tribute to the Cypherpunk movement, which has been campaigning for the protection of privacy on the internet since the early 90s, and was behind the creation of bitcoin in 2008.</p>
                                <p>This series takes up the graphic universe of a character that I invented and gained some popularity in the crypto art scene : the cryptodude.A personification of crypto culture, the Cypherdude performs actions that visually translate the expressions and behaviors specific to this ecosystem</p>
                                <p>Each work in the series is unique and generated from an algorithm hosted directly on the blockchain. The parameters composing each work are selected from a wide range of elements created individually by myself and combined in a seeded random way. Each seed is determined by the blockchain on mint.</p>
                                <p>THE MESSAGE AND/ON THE WORK</p>
                                <p>Each owner of a work from the series has access to a hidden feature : the ability to inscribe an encrypted message in the work itself. The encryption key is decided by the owner on every inscription. This message can then only be decoded by a recipient knowing the key. This way, the work becomes a veritable tool at the service of its owner, who, by using it, makes it evolve visually using a simple steganographic technique.</p>
                                <p>The Cypherdudes thus becomes the visual witness to the presence of a message, and its digital security vault.</p>
                            </div>
                        </div>
                        <div id="actions_C" class="tabContentC1">
                            <div class="tabs">
                                <button id="dO2_C" class="tablinks_C2 h1Text" onclick="openTab_C(event,2,'token_C')">Token Infos</button>
                                <button id="dO2b_C" class="tablinks_C2 h1Text" onclick="openTab_C(event,2,'decode_C')">Decode</button>
                                <button id="dO2c_C" class="tablinks_C2 h1Text" onclick="openTab_C(event,2,'encode_C')">Encode</button>
                            </div>
                            <div>
                                <div id="token_C" class="tabContentC2 pText">
                                    <div style="font-size:13px" class="h2Text">${secretWord.toUpperCase()} - CYPHERDUDE #${tokenId.toString().padStart(4, '0')}</div>
                                    <div>
                                        <ul>
                                            <li>Encoding Capacity : ${chCnt} characters</li>
                                            <li>Grid Size : ${gridSize} squares side</li>
                                            <li>Resolution : ${sqrSR === 0.3 ? 'Low' : sqrSR === 0.2 ? 'Medium' : 'High'}</li>
                                            <li>Level progression : step ${33 - levelProgression} on 32 (${levelProgression} steps left before next stage)</li>
                                            <li>Global progression : ${+(Math.round((squares.length / 10000) * 100 + "e+2") + "e-2")} %</li>
                                            <li>Action : ${dude.name}</li>
                                            <li>Least Significant Bit : 01011000 0101100${lsb > 0 ? 0 : 1}</li>
                                            <li>Layer 1 : ${p1[layer1].p1Name}</li>
                                            <li>Layer 2 : ${hasLayer2 ? layer2_.p2Name : 'none'}</li>
                                            <li>Layer 3 : ${hasLayer3 ? p3[layer3].p1Name : 'none'}</li>
                                            <li>Secret word : ${secretWord.toUpperCase()}</li>
                                            <li>Bit Environment : ${bkgName}</li>
                                            <li>Bit Palette : ${palette.names.a + " / " + palette.names.b + " / " + palette.names.c}</li>
                                        </ul>
                                        <div style="display:flex;"><button class="subBtn h1Text" style="font-size:10px;margin:0 5px 0 0;width:12%" onclick="sendLSB()">Switch</br>LSB</button><p>You can switch your cypherdude Least Significant Bit anytime.</br>It's a free world ! Enjoy!</p></div>
                                        <p>You have the possibility to archive your encrypted message in the Cypherdudes Immutable Archives in the form of a erc-721 token. The messages will remain encrypted and the secret key used for encryption will be the only way to decipher them.</br>You have two options :</p>
                                        <div style="display:flex;"><button class="subBtn h1Text" style="font-size:10px;width:30%;margin:0 5px 1px 0;flex-shrink:2" onclick="sendPublic()">Public archive</button><p>For the Public archive, the secret key will be public and displayed on the token's cover. You will have to type it during the process.</p></div>
                                        <div style="display:flex;"><button class="subBtn h1Text" style="font-size:10px;width:30%;margin:5px 5px 0 0;flex-shrink:2" onclick="sendPrivate()">Private archive</button><p>For the Private archive, the secret key will not be disclosed, letting the message accessible only to those who know the secret key.</p></div>
                                    </div>
                                </div>
                                <div id="decode_C" class="tabContentC2 pText">
                                    <div class="h2Text">Secret Key</div>
                                    <input class="input key" type="password" id="dKey"></input>
                                    <button class="subBtn h1Text" style="margin:5px 0 5px 0" onclick="sendDecode()">Decode</button>
                                    <div class="scroller" style="height:235px">
                                        <div id="decodedData">Once decoded, the message will appear here.
                                        </div>
                                    </div>
                                </div>
                                <div id="encode_C" class="tabContentC2 pText">
                                    <div class="h2Text cWp"><div>Secret Key</div><div class="pText cNt"><span id="kCnt">0</span> / 42</span></div></div>
                                    <input class="input key" onKeyUp="charCount(event,'eKey','k')" placeholder="Your key..." maxlength="42" type="password" id="eKey"></input>
                                    <div class="h2Text cWp" style="margin-top:5px"><div>Message</div><div class="pText cNt"><span id="mCnt">0</span> / ${chCnt}</div></div>
                                    <textarea class="input" onKeyUp="charCount(event,'mess','m')" placeholder="Your message..." type="text" maxlength="${(Math.floor(((squares.length * 8) / 64) - 3) * 32)}" id="mess"></textarea>
                                    <button class="subBtn h1Text" style="margin:5px 0 0 0" onclick="sendEncode()">Encode</button>
                                </div>
                            </div>
                        </div>
                        <div class="fText">--- FELIXFELIXFELIX ---</div>
                    </div>
                </html>
            </foreignObject></g>`;

        // -- DISPLAY SCRIPT -- //
        svgCode += `<script id="svgScript3" type="text/javascript"> <![CDATA[
            var icos = document.getElementsByClassName('ico');
            for (var i = 0; i < icos.length; i++) {
                icos[i].addEventListener('mouseover', mouseOverEffect);
                icos[i].addEventListener('mouseout', mouseOutEffect);
            }
            function mouseOverEffect() {
                this.classList.add("hL");
                document.getElementById('tmp_D2').style.display = "block";
                document.getElementById('tmp_ta').style.display = "block";
                document.getElementById('tmp_ta1').innerHTML = this.getAttribute('alt1');
                document.getElementById('tmp_ta2').innerHTML = this.getAttribute('alt2');
                document.getElementById('tmp_ta3').innerHTML = this.getAttribute('alt3');
            }
            function mouseOutEffect() {
                this.classList.remove("hL");
                document.getElementById('tmp_D2').style.display = "none";
                document.getElementById('tmp_ta').style.display = "none";
            }
            var s_witch = function(evt) {
                var f = document.getElementById('s_p2').getAttribute('fill');
                if (f === 'url(#off)') {
                    document.getElementById('s_p2').setAttribute('fill', 'url(#on)');
                    document.getElementById('cypherdude').unpauseAnimations();
                } else {
                    document.getElementById('s_p2').setAttribute('fill', 'url(#off)');
                    document.getElementById('cypherdude').pauseAnimations();
                }
            }
            document.getElementById('dO1_C').click();
            document.getElementById('dO2_C').click();
            function openTab_C(event, nb, id) {
                var i, tabContentC, tablinks_C;
                tabContentC = document.getElementsByClassName("tabContentC" + nb);
                for (i = 0; i < tabContentC.length; i++) {
                    tabContentC[i].style.display = "none";
                }
                tablinks_C = document.getElementsByClassName("tablinks_C" + nb);
                for (i = 0; i < tablinks_C.length; i++) {
                    tablinks_C[i].className = tablinks_C[i].className.replace(" active", "");
                }
                document.getElementById(id).style.display = "block";
                event.currentTarget.className += " active";
            }
            function sendDecode(){
                var decodeEvent = new Event('decode');
                window.parent.dispatchEvent(decodeEvent);
            }
            function sendEncode(){
                var encodeEvent = new Event('encode');
                window.parent.dispatchEvent(encodeEvent);
            }
            function sendLSB(){
                var lsbEvent = new Event('lsb');
                window.parent.dispatchEvent(lsbEvent);
            }
            function sendPublic(){
                var publicArchiveEvent = new Event('publicArchive');
                window.parent.dispatchEvent(publicArchiveEvent);
            }
            function sendPrivate(){
                var privateArchiveEvent = new Event('privateArchive');
                window.parent.dispatchEvent(privateArchiveEvent);
            }
            if (document.getElementById('clock')) {
                var cvs = document.querySelector('#clock').innerHTML;
            
                function clock() {
                    if (document.getElementById('clock')){
                        document.querySelector('#clock').innerHTML = Date.now();
                        setTimeout(clock, 1);
                    }
                }
                clock();
            }
               ]]>
          </script>`;
        svgCode += `</svg></div>`;
        return svgCode;
    }

    function maptoRange(t, e, a, n, r) {
        return (t - e) * (r - n) / (a - e) + n
    }
    function getProg(t, e, a, n) {
        var r = (n ? 17 : 0) + maptoRange(t, e, a, 1, 16) * (n ? -1 : 1), d = ""; for (let t = 0; t < Math.floor(r); t++)d += "■"; return d
    }
    function dumpBin(t, e, a) {
        var n = ""; for (let r = 0; r < a; r++)n += `${a > 1 ? " " : ""}${t[e]}`;
        return n
    }
}
export default CypherMenu;